import { MSG, wa } from "../../data/site";
import { WhatsAppIcon } from "./Icons";
import { Reveal } from "./Reveal";

export const About = () => (
    <section id="sobre" data-testid="about-section" className="bg-[#FAFCFF] py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl items-center gap-16 px-4 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8">
            <Reveal className="relative order-2 lg:order-1">
                <div className="relative mx-auto max-w-md lg:max-w-none">
                    <div
                        className="absolute -inset-3 -z-0 translate-x-4 translate-y-4 rounded-[2.5rem] bg-[#EFF5FF]"
                        aria-hidden="true"
                    />
                    <img
                        src="/images/about-doctor.jpg"
                        alt="Dr. Gabriel Riccio realizando procedimento com microscópio operatório"
                        data-testid="about-doctor-photo"
                        loading="lazy"
                        className="relative aspect-square w-full rounded-[2.5rem] object-cover shadow-xl shadow-slate-900/10"
                    />
                    <div className="absolute -bottom-6 left-6 rounded-2xl border border-slate-200/80 bg-white/95 px-5 py-4 shadow-lg backdrop-blur sm:left-10">
                        <p className="font-heading text-sm font-bold text-slate-900">
                            Microscopia operatória
                        </p>
                        <p className="mt-0.5 text-xs text-slate-500">
                            Precisão na visualização de cada detalhe
                        </p>
                    </div>
                </div>
            </Reveal>

            <div className="order-1 lg:order-2">
                <Reveal>
                    <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#1A6AFF]">
                        Sobre o especialista
                    </p>
                </Reveal>
                <Reveal delay={0.08}>
                    <h2 className="mt-4 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
                        Conheça seu endodontista
                    </h2>
                </Reveal>
                <Reveal delay={0.16}>
                    <div className="mt-6 space-y-5 text-base leading-relaxed text-slate-600">
                        <p>
                            Dr. Gabriel Riccio é cirurgião-dentista especialista em Endodontia, com
                            atuação dedicada ao diagnóstico e tratamento de doenças da polpa dentária
                            e dos tecidos periapicais.
                        </p>
                        <p>
                            Utilizando microscopia operatória, tecnologia que auxilia na visualização
                            de detalhes e na precisão dos procedimentos, realiza tratamentos
                            endodônticos com foco na preservação dos dentes naturais, inclusive em
                            casos de maior complexidade.
                        </p>
                        <p>
                            Atuando em Santos, Dr. Gabriel Riccio valoriza um atendimento humanizado,
                            acolhedor e individualizado. Seu trabalho busca aliar conhecimento
                            técnico, tecnologia e cuidado para oferecer uma experiência segura e
                            atenta às necessidades de cada paciente.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.24}>
                    <a
                        href={wa(MSG.consulta)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="about-whatsapp-button"
                        className="mt-9 inline-flex items-center gap-2.5 rounded-full bg-[#1A6AFF] px-7 py-4 text-sm font-semibold text-white shadow-xl shadow-blue-600/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#0052E0]"
                    >
                        <WhatsAppIcon className="h-5 w-5" />
                        Quero mais informações
                    </a>
                </Reveal>
            </div>
        </div>
    </section>
);
